var DateFilter = React.createClass({
  propTypes: {
    searchDates: React.PropTypes.object.isRequired,
    selectedStartDate: React.PropTypes.string,
    onDateChanged: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      selectedStartDate: ""
    }
  },
  dateClicked(startDate) {
    let endDate = startDate.length ? this.props.searchDates.today.endDate : "";

    if (this.props.onDateChanged) {
      this.props.onDateChanged(startDate, endDate);
    }
  },
  render() {
    let {searchDates} = this.props;
    let items = [
      {label: Labels.getLabel("Any Time"),      value: ""},
      {label: Labels.getLabel("Today"),         value: searchDates.today.startDate},
      {label: Labels.getLabel("Past week"),     value: searchDates.pastWeek.startDate},
      {label: Labels.getLabel("Past month"),    value: searchDates.pastMonth.startDate},
      {label: Labels.getLabel("Past 6 months"), value: searchDates.pastSixMonths.startDate},
    ];

    return (
     <BrowseFilter title={Labels.getLabel("Modified Date")} filterType="filter-type__date" ariaLabel="Solution Modified Date filter" isOpen={this.props.isOpen}>
        <FilterLinkList
          items={items}
          selectedValue={this.props.selectedStartDate}
          onClick={this.dateClicked} />
      </BrowseFilter>
    )
  }
});